import { gql } from "@apollo/client";

export const AddStockManufacturer = gql`
  mutation AddStockManufacturer(
    $token: String!
    $manufacturer: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
  ) {
    AddStockManufacturer(
      token: $token
      manufacturer: $manufacturer
      customer_id: $customer_id
      user_details: $user_details
    )
  }
`;

export const UpdateStockManufacturer = gql`
  mutation UpdateStockManufacturer(
    $token: String!
    $manufacturer_id: ID!
    $user_details: SubscribedUser!
    $manufacturer: String!
  ) {
    UpdateStockManufacturer(
      token: $token
      manufacturer_id: $manufacturer_id
      user_details: $user_details
      manufacturer: $manufacturer
    )
  }
`;

export const DeleteStockManufacturer = gql`
  mutation DeleteStockManufacturer(
    $token: String!
    $manufacturer_id: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteStockManufacturer(
      token: $token
      manufacturer_id: $manufacturer_id
      user_details: $user_details
    )
  }
`;
